<template>
	<div class="wrapper">
		<div class="headerDiv wrapper">
			<i class="back" @click="back"></i>
			<span>我的订单</span>
		</div>
		<ul class="orderUl">
			<li @click="loadOrderInfo('all',1)" :class="{active:cur== 'all'}">全部</li>
			<li @click="loadOrderInfo('pay',1)" :class="{active:cur=='pay'}">已支付</li>
			<li @click="loadOrderInfo('notpay',1)" :class="{active:cur=='notpay'}">待支付</li>
			<li @click="loadOrderInfo('cancel',1)" :class="{active:cur=='cancel'}">已取消</li>
			<li @click="loadOrderInfo('refund',1)" :class="{active:cur=='refund'}">已退款</li>
		</ul>
		
		
		<van-list
			   :immediate-check="false"
			   v-model="loading"
			   :finished="finished"
			   finished-text="没有更多了"
			   @load="onLoad"
			   v-show="!notFoundShow"
			>
			<div class="orderTab">
				<div class="orderTab-div1">
					<div class="orderMain" v-for="item in list">
						
						<router-link :to="{ name:'orderDetail', params: {orderNo: item.mealNo} }">
							<p>
								<span>{{item.mealNo}}</span>
								<span class="status_dzf" v-if="item.orderStatus == 1">待支付</span>
								<span class="status_yzf" v-else-if="item.orderStatus == 2">已支付</span>
								<span class="status_ytk" v-else-if="item.orderStatus == 3">已退款</span>
								<span class="status_yqx" v-else-if="item.orderStatus == 4">已取消</span>
							</p>
							<p>
								<img :src="item.picPath" alt="" />
								<span>{{item.name}}</span>
								<span>￥{{item.orderPrice}}</span>
							</p>
						</router-link>
						
						<p class="clear">
							<a class="btn_qzf" v-if="item.orderStatus == 1" @click="gopay(item.mealNo)">去支付</a>
							<a class="btn_del" v-if="item.orderStatus == 1" @click="cancelOrder(item.mealNo)" :disabled="qxDisable">取消订单</a>
							<a class="btn_qzf" v-else-if="item.orderStatus == 2" @click="runThis">
								<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.4rem; vertical-align: -5px;" />
								售后客服
							</a>
							<a class="btn_qzf" v-else-if="item.orderStatus == 3" @click="runThis">
								<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.4rem; vertical-align: -5px;" />
								售后客服
							</a>
							<a class="btn_del" v-else-if="item.orderStatus == 4" @click="againDownOrder(item.orderType,item.productId)">重新下单</a>
						</p>
					</div>
				</div>
			</div>
			
		</van-list>
		
		<notFound v-show="notFoundShow" style="margin-top: 12rem;"/>
		
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/order.scss"
    import footerTag from '@/components/footerTag/footerTag.vue'
    import notFound from '@/components/notFound/notFound.vue'
    import { List,Dialog } from 'vant'
    import {GetParamValue} from '../../assets/js/getParam.js' 
    import { openConsult } from '../../assets/js/common.js' 
	
	export default {
	    name: 'orderList',
		data(){
			  return {
			  	cur:'all',
			 	list: [],
		    	loading: false,
		    	finished: false,
				page:1,
				limit:10,
				total:'',
				qxDisable:false,
				notFoundShow:false,
			  }
		},
		methods:{
			 back(){
			 	this.$router.push({ name:'userIndex' });
			 },
			 loadOrderInfo(type,pageNum){
			 	if(pageNum == 1){
			 		this.list=[];
			 		this.total='';
			 	}
			 	this.cur=type;
			 	this.axios({
			 	    method: 'POST',
			 	    url:'/order/findOrderList',
			 		params:{
			 			status:""+type,
			 			page:pageNum,
			 			limit:this.limit
			 		},
			 	}).then((res)=>{
			 			if(res.data.code==1000){
			 				let data = res.data.data;
			 				let dataList=data.list;
			 				if(dataList != null && dataList.length > 0){
			 					for(var i=0,len=dataList.length;i<len;i++){
			 						let _data=dataList[i];
			 						if(_data.orderType == 99){
			 							_data.name = "企业变更+1年代理记账";
			 						}
			 						_data.picPath=GetParamValue.getProductPic(_data.orderType);
			 					}
			 				}
			 				
							this.list=this.list.concat(dataList); 
							this.total=data.total;
							if(this.total == 0){
								this.notFoundShow=true;
							}else{
								this.notFoundShow=false;
							}
			 			}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
			  			}else{
							 this.$message.error({message: '网络异常，返回重试'});
				 		}
			 	}).catch((err)=>{
			 		 this.$message.error({message: '获取数据失败'});
			 	})
			 },
			 onLoad() {
			       // 异步更新数据
			       setTimeout(() => {
					 this.page++;
					 this.loadOrderInfo(this.cur,this.page);
			         // 加载状态结束
			         this.loading = false;
			         // 数据全部加载完成
					  if (this.list.length >= this.total) {
					        this.finished = true;
					    }
			       }, 500);
			 },
			 runThis(){
				this.axios({
				    method: 'POST',
				    url:'/user/selectSaleQQ',
				}).then((res)=>{
					openConsult(res.data.obj);
				}).catch((err)=>{
					this.$message.error({message: '暂无客服人员'});
				}) 
			 },
			 //取消订单
			 cancelOrder(orderNo){
			 		//按钮不可点击
					this.qxDisable=true;
				 	Dialog.confirm({
					  title: '提示',
					  message: '确认要取消订单 '+orderNo+'？<br/>确认后将立即生效，无法撤回。'
					}).then(() => {
					  // 确认
					  this.axios({
					 	    method: 'POST',
					 	    url:'/order/cancel',
					 		params:{
					 			orderNo:orderNo
					 		},
					 	}).then((res)=>{
					 			//按钮可点击
								this.qxDisable=false;
					 			if (res.data.code == 1000) {
						            Dialog.alert({
									  message: '订单'+orderNo+'取消成功！'
									}).then(() => {
										// 返回订单列表
									  	window.location.href='/order/orderInfo';
									});
						        }else if(res.data.code == 1110){
						  			//未登录
						  			let currPath=window.location.href;
						  			window.location.href='/login?targetUrl='+currPath;
					  			}else if(res.data.code == 5103){
								    this.$message.error({message: '该订单不属于待支付订单'});
						        }else{
						        	this.$message.error({message: '网络异常，请稍后重试'});
						        }
					 	}).catch((err)=>{
					 		 //按钮可点击
							 this.qxDisable=false;
					 		 this.$message.error({message: '网络异常，请稍后重试'});
					 	})
					}).catch(() => {
					  	// 取消
					  	//按钮可点击
						this.qxDisable=false;
					});
			 },
			 againDownOrder(productName,mealId){
			 	if(Number(productName)== 99){
					this.$router.push({ name:'productMeal', params: {id:mealId} });
				}else if(Number(productName)== 1){
					// 公司注册
					this.$router.push({ name:'againGszc', params: {pid:mealId} });
				}else if(Number(productName)== 2){
					// 代理记账
					this.$router.push({ name:'againDljz', params: {pid:mealId} });
				}else if(Number(productName)== 3){
					// 企业变更
					this.$router.push({ name:'againQybg', params: {pid:mealId} });
				}else if(Number(productName)== 4){
					// 地址异常处理
					this.$router.push({ name:'againDzyccl', params: {pid:mealId} });
				}else if(Number(productName)== 5){
					//开设基本户
					this.$router.push({ name:'againKsjbh', params: {pid:mealId} });
				}else if(Number(productName)== 6){
					//公司注销
					this.$router.push({ name:'againGszx', params: {pid:mealId} });
				}else if(Number(productName)== 7){
					//税务筹划
					this.$router.push({ name:'againSwch', params: {pid:mealId} });
				}else if(Number(productName)== 8){
					//发票申领
					this.$router.push({ name:'againFpsl', params: {pid:mealId} });
				}else if(Number(productName)== 9){
					//税务解非
					this.$router.push({ name:'againSwjf', params: {pid:mealId} });
				}else if(Number(productName)== 10){
					//年度汇算清缴
					this.$router.push({ name:'againNdhsqj', params: {pid:mealId} });
				}else if(Number(productName)== 11){
					//年度工商年报
					this.$router.push({ name:'againNdgsnb', params: {pid:mealId} });
				}else if(Number(productName)== 12){
					//食品经营许可证
					this.$router.push({ name:'againSpjyxkz', params: {pid:mealId} });
				}else if(Number(productName)== 13){
					//财税咨询
					this.$router.push({ name:'againCszx', params: {pid:mealId} });
				}else if(Number(productName)== 14){
					//香港公司注册
					this.$router.push({ name:'againXggszc', params: {pid:mealId} });
				}else if(Number(productName)== 15){
					//香港公司注销
					this.$router.push({ name:'againXggszx', params: {pid:mealId} });
				}else if(Number(productName)== 16){
					//开设一般户
					this.$router.push({ name:'againKsybh', params: {pid:mealId} });
				}else if(Number(productName)== 17){
					//刻章备案
					this.$router.push({ name:'againKzba', params: {pid:mealId} });
				}else if(Number(productName)== 18){
					//社保开户
					this.$router.push({ name:'againSbkh', params: {pid:mealId} });
				}else if(Number(productName)== 19){
					//开设公积金账户
					this.$router.push({ name:'againKsgjjzh', params: {pid:mealId} });
				}else if(Number(productName)== 20){
					//定制代记账方案
					this.$router.push({ name:'againDzdjzfa', params: {pid:mealId} });
				}else if(Number(productName)== 21){
					//旧账梳理
					this.$router.push({ name:'againJzsl', params: {pid:mealId} });
				}else if(Number(productName)== 22){
					//年报异常解非
					this.$router.push({ name:'againNbycjf', params: {pid:mealId} });
				}else if(Number(productName)== 23){
					//开票咨询
					this.$router.push({ name:'againKpzx', params: {pid:mealId} });
				}else if(Number(productName)== 24){
					//外勤上门服务
					this.$router.push({ name:'againWqsmfw', params: {pid:mealId} });
				}else if(Number(productName)== 25){
					//电商客服外包
					this.$router.push({ name:'againDskfwb', params: {pid:mealId} });
				}else if(Number(productName)== 26){
					//劳务派遣许可证
					this.$router.push({ name:'againLwpqxkz', params: {pid:mealId} });
				}else if(Number(productName)== 27){
					//道路运输许可证
					this.$router.push({ name:'againDlysxkz', params: {pid:mealId} });
				}else if(Number(productName)== 28){
					//游戏出版运营备案
					this.$router.push({ name:'againYxcbyyba', params: {pid:mealId} });
				}else if(Number(productName)== 29){
					//ODI境外投资
					this.$router.push({ name:'againJwtz', params: {pid:mealId} });
				}
			 },
			 // 去支付
			gopay(orderNo){
				this.$router.push({ name:'paySure', params: {orderNo:orderNo} });
			},
		},
	    components: {
	        footerTag,
	        notFound,
	        [List.name]:List,
	        Dialog,
	        GetParamValue,
	        openConsult
	    },
	    created(){
			this.loadOrderInfo('all');
		}
	}
</script>


